module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/twitter-37a1a53a72541fdd419bf113b2246f3f.svg";